import { createClient } from '@supabase/supabase-js';
import { PUBLIC_SUPABASE_URL, PUBLIC_SUPABASE_ANON_KEY } from '$env/static/public';
import { browser } from '$app/environment';

console.log('クライアントSupabase初期化:', {
  url: PUBLIC_SUPABASE_URL ? PUBLIC_SUPABASE_URL.substring(0, 10) + '...' : 'undefined',
  hasKey: !!PUBLIC_SUPABASE_ANON_KEY,
  isBrowser: browser
});

// ブラウザ環境でのCookie確認
if (browser) {
  console.log('ブラウザCookie:', {
    hasCookies: !!document.cookie,
    hasSubapseAuth: document.cookie.includes('sb-')
  });
}

export const supabase = createClient(
    PUBLIC_SUPABASE_URL, 
    PUBLIC_SUPABASE_ANON_KEY,
    {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        storageKey: 'sb-auth-token'
      }
    }
);